import { EditIcon } from '@carboncopyco/icons';
import { ModificationItem } from './ModificationItem';
import { inputLabel } from './utils';

export const InputModificationItem = () => {
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <EditIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text label={inputLabel} />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
